export default function capitalizeFirstLetter(string){
    const STR = string && String(string);
    return string && STR.charAt(0).toUpperCase() + STR.slice(1).toLowerCase();
}

const capitalizeFirstWord = (data) => data?.replace(/_/g, ' ')?.toLowerCase()?.replace(/\b\w/g, (c) => c.toUpperCase());

export {
    capitalizeFirstWord
};